import { render } from "./nameLabel.vue?vue&type=template&id=2e1bab43&scoped=true"
import script from "./nameLabel.vue?vue&type=script&lang=js"
export * from "./nameLabel.vue?vue&type=script&lang=js"

import "./nameLabel.vue?vue&type=style&index=0&id=2e1bab43&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e1bab43"]])

export default __exports__